module.exports = __webpack_public_path__ + "static/media/modules.8dbc9a14.png";